(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/helpers/suspension-helpers.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/helpers/suspension-helpers.js');

'use strict';

const getLastSuspension = suspensions => {
  let lastSuspension = suspensions.suspensions.filter(suspension => suspension.product === 'all');
  lastSuspension = lastSuspension.reduce((preVal, currVal) => {
    if (Boolean(preVal) && new Date(preVal.validTo || preVal.terminable) > new Date(currVal.validTo || currVal.terminable)) {
      return preVal;
    }
    return currVal;
  }, undefined);
  return lastSuspension;
};

const getSuspensionPeriod = suspension => {
  const period = suspension.period > 0 ? suspension.period : suspension.terminationPeriod || 0;
  if (period === 0) {
    return '';
  } else if (period < 12) {
    return "".concat(period, " m\xE5nader");
  }
  return "".concat(period / 12, " \xE5r");
};

const getTotalPeriod = (period, terminationPeriod) => {
  const pp = isNaN(period) ? 0 : period;
  const pt = isNaN(terminationPeriod) ? 0 : terminationPeriod;
  const totalPeriod = pp + pt;
  return totalPeriod;
};

const getProductName = (product, capitalize, period) => {
  let productName = '';
  switch (product) {
    case 'all':
      productName = capitalize ? 'Alla spel' : 'alla spel';
      break;
    case 'poker':
      productName = 'Poker';
      break;
    case 'vegas':
      productName = 'Vegas';
      break;
    case 'quickGames':
      if (typeof period === 'string' || typeof period === 'number') {
        productName = period > 0 ? 'Lotter och KenoXpress' : 'Spelpaus24';
      } else if (typeof period === 'undefined') {
        productName = 'Lotter och KenoXpress';
      } else {
        productName = 'Spelpaus24';
      }
      break;
    default:
      productName = 'aktiv';
  }
  return productName;
};
svs.accountservicesReact.deposit.helpers.suspensionHelper = {
  getLastSuspension,
  getSuspensionPeriod,
  getTotalPeriod,
  getProductName
};

 })(window);